import { render } from "./market-prices.vue?vue&type=template&id=11cad549&scoped=true&lang=pug"
import script from "./market-prices.vue?vue&type=script&lang=js"
export * from "./market-prices.vue?vue&type=script&lang=js"

import "./market-prices.vue?vue&type=style&index=0&id=11cad549&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cad549"]])

export default __exports__